import React from "react";
import { Link } from "gatsby"
import LocRatingMap from "../map/loc-rating-map-details"

import "./Map.scss";

const Map = ({ property_data, setPlay, clickFloorplan }) => {

    const shareurl = typeof window !== 'undefined' ? window.location.href : ''

    // Get Map Details
    let mapItems = [];
    let mapItem = {};
    mapItem['lat'] = property_data.latitude
    mapItem['lng'] = property_data.longitude
    mapItem['id'] = property_data.id

    const mapMarkerImageShowFlag = 0;
    mapItems.push(mapItem);
    // Get Map Details

    var brochure_url = property_data?.selling_info?.publicBrochureUrl ? property_data?.selling_info?.publicBrochureUrl  : "";

    var home_report = property_data?.brochure?.length > 0 ? property_data?.brochure[0] : "";

    //console.log("home_report", property_data?.brochure)

    const trackerBrochure = (event) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'Download '+event,
            'formType': event + ' - ' + shareurl,
            'formId': event,
            'formName': event,
            'formLabel': event
        });
    }

    return (
        <React.Fragment>
            <section className="locarating-map">
                {(property_data?.video_tour?.url || property_data?.floorplan?.length > 0 || brochure_url || property_data?.epc?.length > 0) &&
                    <div className="more-info">
                        <div className="h4">More Information</div>
                        <div className="info-wrap">
                            {property_data?.video_tour && property_data?.video_tour?.url &&
                                <a href="javascript:;" className="icon-wrap" onClick={e => { setPlay(true) }}>
                                    <i className="camera"></i>
                                    <span className="text">Video Tour</span>
                                </a>
                            }

                            {property_data?.floorplan?.length > 0 &&
                                <a href="javascript:;" className="icon-wrap" onClick={() => clickFloorplan("floor_plan")}>
                                    <i className="floor"></i>
                                    <span className="text">Floorplans</span>
                                </a>
                            }
                            {brochure_url &&
                                <a href={brochure_url} onClick={() => trackerBrochure('Brochure')} className="icon-wrap" target={"_blank"}>
                                    <i className="brochure"></i>
                                    <span className="text">Brochure</span>
                                </a>
                            }

                            {property_data?.epc?.length > 0 &&
                                <a href="javascript:;" className="icon-wrap" onClick={() => clickFloorplan("epc")}>
                                    <i className="energy"></i>
                                    <span className="text">Energy Performance Certificate</span>
                                </a>
                            }

                            {/* {home_report &&
                                <a href={home_report} onClick={() => trackerBrochure('Home Report')} className="icon-wrap" target={"_blank"}>
                                    <i className="home_icon"></i>
                                    <span className="text">Home Report</span>
                                </a>
                            } */}

                            {process.env.GATSBY_SITE_NAME === "Linley and Simpson" && 
                                (property_data?.search_type === "lettings" && 
                                <Link to={"/our-charges/"} className="icon-wrap">
                                    <i className="money_icon"></i>
                                    <span className="text">Fees & Charges</span>
                                </Link>)
                            }
                            
                        </div>
                    </div>
                }

                <div className="map-img">
                    <LocRatingMap data={mapItems} sold_price_tab={property_data?.department === "commercial" ? false : true} />
                </div>
            </section>

        </React.Fragment>
    );
};
export default Map;
